export default __webpack_public_path__ + "static/media/17life.c4fcf662.png";